import { useEffect, useState } from 'react';
import Sidebar from '../../../shared/layouts-components/sidebar/sidebar';
import { data$, getState } from '../../../shared/services/switcherServices';

const SIDEBAR_SELECTOR = '#sidebar';
const ORIGINAL_TABINDEX_ATTRIBUTE = 'data-cares-original-tabindex';

const syncMobileSidebarFocusability = () => {
  const sidebar = document.querySelector(SIDEBAR_SELECTOR);
  if (!(sidebar instanceof HTMLElement)) {
    return;
  }

  const sidebarHiddenOnMobile = window.innerWidth <= 992 && getState().toggled === 'close';
  const focusableElements = sidebar.querySelectorAll<HTMLElement>(
    'a[href], button, input, select, textarea, [tabindex]'
  );

  sidebar.setAttribute('aria-hidden', sidebarHiddenOnMobile ? 'true' : 'false');

  focusableElements.forEach((element) => {
    if (sidebarHiddenOnMobile) {
      if (!element.hasAttribute(ORIGINAL_TABINDEX_ATTRIBUTE)) {
        element.setAttribute(
          ORIGINAL_TABINDEX_ATTRIBUTE,
          element.getAttribute('tabindex') ?? ''
        );
      }

      element.setAttribute('tabindex', '-1');
      return;
    }

    const originalTabIndex = element.getAttribute(ORIGINAL_TABINDEX_ATTRIBUTE);
    if (originalTabIndex === null) {
      return;
    }

    if (originalTabIndex === '') {
      element.removeAttribute('tabindex');
    } else {
      element.setAttribute('tabindex', originalTabIndex);
    }

    element.removeAttribute(ORIGINAL_TABINDEX_ATTRIBUTE);
  });
};

const CaresAuthenticatedSidebar = () => {
  const [sidebarToggleState, setSidebarToggleState] = useState(getState().toggled);

  useEffect(() => {
    const subscription = data$.subscribe((nextState) => {
      setSidebarToggleState(nextState.toggled);
    });

    return () => subscription.unsubscribe();
  }, []);

  useEffect(() => {
    const applyFocusability = () => {
      window.requestAnimationFrame(syncMobileSidebarFocusability);
    };

    applyFocusability();
    window.addEventListener('resize', applyFocusability);

    return () => {
      window.removeEventListener('resize', applyFocusability);
    };
  }, [sidebarToggleState]);

  return <Sidebar />;
};

export default CaresAuthenticatedSidebar;
